import { configureStore } from '@reduxjs/toolkit'
import { connectRouter } from 'connected-react-router'
import compReducer from 'global/Reducer/compSlice'
import dataReducer from 'global/Reducer/dataSlice'
import statusReducer from 'global/Reducer/statusSlice'
import { createBrowserHistory } from 'history'

export const history = createBrowserHistory({ basename: "/editor" })

const store = configureStore({
  reducer: {
    router: connectRouter(history)!,
    status: statusReducer,
    data: dataReducer,
    comp: compReducer,
  },
  middleware: ((getDefaultMiddleware) => getDefaultMiddleware({
    immutableCheck: { ignoredPaths: ['data.config', 'comp.leftSnap.config', 'comp.rightSnap.config', 'comp.mergeSnap.config'] },
    serializableCheck: {
      ignoredPaths: ['data.config', 'comp.leftSnap.config', 'comp.rightSnap.config', 'comp.mergeSnap.config'],
      ignoredActions: ['data/setConfig', 'comp/changeMergeSnap', 'comp/loadMergeSnap', 'comp/loadRightSnap', 'comp/loadLeftSnap', 'data/updateSnapshotData'],
    },

  }))
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store;